import "./EventStats.css";
import Spinner from "../../components/Spinner";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { EVENT } from "../../api/event";
import {
  BasketballStats,
  FootballStats,
  CricketStats,
  EgamingStats,
  BadmintonStats,
  IndividualStats,
} from "./Stats";
import captureException from "../../utils/captureException";

function EventStats() {
  const { id } = useParams();
  const { loading, error, data } = useQuery(EVENT, { variables: { id } });

  if (error) {
    captureException({
      error,
      info: {
        type: "query",
        component: "EventStats",
        query: "EVENT",
      },
    });
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    return (
      <div
        style={{
          height: "160px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spinner />
      </div>
    );
  }

  const event = data.event;
  const sport = event.sport.name;

  return (
    <div className="event-stats">
      {sport === "Football" && <FootballStats id={id} event={event} />}
      {sport.includes("Basketball") && (
        <BasketballStats id={id} event={event} />
      )}
      {sport.includes("Cricket") && <CricketStats id={id} event={event} />}
      {sport === "Tennis" && <IndividualStats id={id} event={event} />}
      {sport === "Badminton" && <BadmintonStats id={id} event={event} />}
      {sport === "Esports" && <EgamingStats id={id} event={event} />}
      {sport === "Other" && <IndividualStats id={id} event={event} />}
    </div>
  );
}

export default EventStats;
